export default {
	h1: {
		fontSize: 30
	}
};
